import { errorLoading, loading, loaded, responseHandler,
  errorGetStatus, tokenInterceptor } from '../manager/HttpManager'
import { fetchLogoutAction, fetchAccountAction } from './AuthWS'
import Constants from '../constants/Constants'

let urlServer = Constants.UrlsConstants.urlServer
let page = 1
let maxPage = 1
let limit = 50
let isFetchingDatas = false

export const adminWS = (state = { users: [], profiles: [], adminApps: [],
  profil: {}, authProperties: [] }, action) => {
  switch (action.type) {
    case Constants.ActionsConstants.ADMIN.SET_USERS:
      return Object.assign({}, state, { users: action.datas })
    case Constants.ActionsConstants.ADMIN.SET_PROFILES:
      return Object.assign({}, state, { profiles: action.datas, profil: {} })
    case Constants.ActionsConstants.ADMIN.DETAIL_PROFIL:
      return Object.assign({}, state, { profil: action.datas })
    case Constants.ActionsConstants.ADMIN.SET_ALL_APPS:
      let apps = state.adminApps.concat(action.datas)
      return Object.assign({}, state, { adminApps: apps })
    case Constants.ActionsConstants.ADMIN.CLEAR_ALL_APPS:
      return Object.assign({}, state, { adminApps: [] })
    case Constants.ActionsConstants.ADMIN.SET_AUTH_PROPERTIES:
      return Object.assign({}, state, { authProperties: action.datas })
    default:
      return state
  }
}

export const setUsers = (data) => {
  return {
    type: Constants.ActionsConstants.ADMIN.SET_USERS,
    datas: data,
  }
}

export function fetchUsersAction (dispatch, user = null, context = null, search = null, identifier = null) {
  function clearUsers () {
    dispatch(setUsers([]))
  }

  function Users () {
    if (identifier == null) {
      identifier = 'USER_FO_OWNER'
    }
    let method = Constants.UrlsConstants.userFOEntryPoint + Constants.MethodsWSConstants.USERS_AND_PROFILES.LIST +
      identifier + '?sort=email'
    if (search) {
      method = method + '&search=' + search
    }
    let headers = {
      'authtoken': Constants.UrlsConstants.header.authtoken,
      'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
      'Content-Type': 'application/json',
    }
    // dispatch(loading(method))
    fetch(urlServer+method, {
      headers,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
    .then(r => r.json())
    .then(data => {
      dispatch(setUsers(data))
    })
    .catch(error => {
      if (errorGetStatus(error) === 401) {
        dispatch(errorLoading('Error.Croutons.authExpired'))
        fetchLogoutAction(dispatch).fetchLogout()
      }
    })
  }

  function Update () {
    if (user) {
      let method = Constants.UrlsConstants.userFOEntryPoint
      let headers = {
        'authtoken': Constants.UrlsConstants.header.authtoken,
        'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
        'Content-Type': 'application/json',
      }
      // dispatch(loading(method))
      fetch(urlServer+method, {
        method: 'PUT',
        headers,
        body: JSON.stringify(user),
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        Users()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
    }
  }

  function changePassword () {
    if (user) {
      let method = Constants.UrlsConstants.userFOEntryPoint+'changePassword'
      let userToConnect = {
        userName: user.userName,
        password: user.password,
      }
      let userToChangePassword = JSON.parse(JSON.stringify(user))
      delete userToChangePassword.userName
      delete userToChangePassword.password
      let headers = {
        'Content-Type': 'application/json',
      }

      // dispatch(loading(method))
      fetch(urlServer+method, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(userToChangePassword),
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
      .then(r => r.json())
      .then(data => {
        if (data.error && data.error === 'INVALID_CODE') {
          dispatch(errorLoading('Error.Croutons.changePasswordFailed'))
        } else {
          dispatch(loaded('Error.Croutons.saveSuccess'))
          fetchAccountAction(dispatch, userToConnect, context).fetchAccount()
        }
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
    }
  }

  function Create () {
    if (user) {
      let method = Constants.UrlsConstants.userFOEntryPoint
      let headers = {
        'authtoken': Constants.UrlsConstants.header.authtoken,
        'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
        'Content-Type': 'application/json',
      }
      // dispatch(loading(method))
      fetch(urlServer+method, {
        method: 'POST',
        headers,
        body: JSON.stringify(user),
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        Users()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else if (errorGetStatus(error) === 409) {
          dispatch(errorLoading('User.errors.alreadyUsed'))
        }
      })
    }
  }

  function Delete () {
    if (user) {
      let method = Constants.UrlsConstants.userFOEntryPoint+'?toDelete='
      method = method + encodeURIComponent(user.email)
      let headers = {
        'authtoken': Constants.UrlsConstants.header.authtoken,
        'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
        'Content-Type': 'application/json',
      }
      // dispatch(loading(method))
      fetch(urlServer+method, {
        method: 'DELETE',
        headers,
      })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        Users()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
    }
  }

  function Reactivate () {
    if (user) {
      let method = Constants.UrlsConstants.userFOEntryPoint + 'reinvite?email='
      method = method + encodeURIComponent(user.email)
      let headers = {
        'authtoken': Constants.UrlsConstants.header.authtoken,
        'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
        'Content-Type': 'application/json',
      }
      fetch(urlServer+method, {
        method: 'GET',
        headers,
      })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        Users()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
    }
  }

  return {
    clearUsers,
    get: Users,
    update: Update,
    changePassword,
    create: Create,
    delete: Delete,
    reactivate: Reactivate,
  }
}

export const setProfiles = (data) => {
  return {
    type: Constants.ActionsConstants.ADMIN.SET_PROFILES,
    datas: data,
  }
}

export const setAuthProperties = (data) => {
  return {
    type: Constants.ActionsConstants.ADMIN.SET_AUTH_PROPERTIES,
    datas: data,
  }
}

export const getDetailProfil = (data) => {
  return {
    type: Constants.ActionsConstants.ADMIN.DETAIL_PROFIL,
    datas: data,
  }
}

export function fetchProfilesAction (dispatch, profile = null, fetchUsers = null) {
  function clearProfiles () {
    dispatch(setProfiles([]))
  }

  function AuthProperties () {
    let method = Constants.UrlsConstants.profilEntryPoint+Constants.MethodsWSConstants.USERS_AND_PROFILES.AUTH_LIST
    let headers = {
      'authtoken': Constants.UrlsConstants.header.authtoken,
      'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
      'Content-Type': 'application/json',
    }
    // dispatch(loading(method))
    fetch(urlServer+method, {
      headers,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
    .then(r => r.json())
    .then(data => {
      // dispatch(loaded(method))
      dispatch(setAuthProperties(data))
    })
    .catch(error => {
      if (errorGetStatus(error) === 401) {
        fetchLogoutAction(dispatch).fetchLogout()
        // window.location.href='/'
      }
    })
  }

  function Profiles (key) {
    let method = Constants.UrlsConstants.profilEntryPoint+Constants.MethodsWSConstants.USERS_AND_PROFILES.LIST
    if (fetchUsers) {
      method = method + key
    }
    method = method + '?sort=name'
    let headers = {
      'authtoken': Constants.UrlsConstants.header.authtoken,
      'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
      'Content-Type': 'application/json',
    }

    fetch(urlServer+method, {
      headers,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
    .then(r => r.json())
    .then(data => {
      dispatch(setProfiles(data))
    })
    .catch(error => {
      if (errorGetStatus(error) === 401) {
        dispatch(errorLoading('Error.Croutons.authExpired'))
        fetchLogoutAction(dispatch).fetchLogout()
      }
    })
  }

  function getFreemiumProfiles () {
    let method = Constants.UrlsConstants.profilEntryPoint+Constants.MethodsWSConstants.USERS_AND_PROFILES.FREEMIUM_LIST
    let headers = {
      'authtoken': Constants.UrlsConstants.header.authtoken,
      'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
      'Content-Type': 'application/json',
    }

    fetch(urlServer+method, {
      headers,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
    .then(r => r.json())
    .then(data => {
      dispatch(setProfiles(data))
    })
    .catch(error => {
      if (errorGetStatus(error) === 401) {
        dispatch(errorLoading('Error.Croutons.authExpired'))
        fetchLogoutAction(dispatch).fetchLogout()
      }
    })
  }

  function Detail (key) {
    if (profile) {
      let method = Constants.UrlsConstants.profilEntryPoint +
                    Constants.MethodsWSConstants.USERS_AND_PROFILES.DETAIL +
                    profile.id
      let headers = {
        'authtoken': Constants.UrlsConstants.header.authtoken,
        'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
        'Content-Type': 'application/json',
      }
      // dispatch(loading(method))
      fetch(urlServer+method, {
        method: 'GET',
        headers,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
      .then(r => r.json())
      .then(data => {
        dispatch(getDetailProfil(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        }
      })
    }
  }

  function Update (key) {
    if (profile) {
      let method = Constants.UrlsConstants.profilEntryPoint
      let headers = {
        'authtoken': Constants.UrlsConstants.header.authtoken,
        'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
        'Content-Type': 'application/json',
      }
      // dispatch(loading(method))
      fetch(urlServer+method, {
        method: 'PUT',
        headers,
        body: JSON.stringify(profile),
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        Profiles(key)
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
    }
  }

  function Create (key) {
    if (profile) {
      let method = Constants.UrlsConstants.profilEntryPoint
      let headers = {
        'authtoken': Constants.UrlsConstants.header.authtoken,
        'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
        'Content-Type': 'application/json',
      }
      // dispatch(loading(method))
      fetch(urlServer+method, {
        method: 'POST',
        headers,
        body: JSON.stringify(profile),
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        Profiles(key)
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
    }
  }

  function Delete (key) {
    if (profile) {
      let method = Constants.UrlsConstants.profilEntryPoint+profile.id
      let headers = {
        'authtoken': Constants.UrlsConstants.header.authtoken,
        'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
        'Content-Type': 'application/json',
      }
      fetch(urlServer+method, {
        method: 'DELETE',
        headers,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        Profiles(key)
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
    }
  }

  return {
    clearProfiles,
    getProperties: AuthProperties,
    get: Profiles,
    getFreemiumProfiles,
    detail: Detail,
    update: Update,
    create: Create,
    delete: Delete,
  }
}

export const setAllApps = (data) => {
  return {
    type: Constants.ActionsConstants.ADMIN.SET_ALL_APPS,
    datas: data,
  }
}

export const setClearAllApps = () => {
  return {
    type: Constants.ActionsConstants.ADMIN.CLEAR_ALL_APPS,
    datas: [],
  }
}

export function fetchAppsAction (dispatch, application) {
  function clearAllApps () {
    page = 1
    maxPage = 1
    isFetchingDatas = false
    dispatch(setClearAllApps())
  }

  function getAllApps () {
    if (page <= maxPage && !isFetchingDatas) {
      isFetchingDatas = true
      let method = Constants.UrlsConstants.appsEntryPoint+Constants.MethodsWSConstants.APPS.FETCH_ALL_APPS
      let headers = {
        'authtoken': Constants.UrlsConstants.header.authtoken,
        'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
        'Content-Type': 'application/json',
      }
      method = method + '?page='+page+'&size='+limit+'&sort=creation&dir=desc'
      fetch(urlServer+method, {
        headers,
      })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        maxPage = data.totalPages
        if (maxPage >= page) page++
        isFetchingDatas = false
        dispatch(setAllApps(data.content))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
    }
  }

  function saveApp () {
    let entryPoint = Constants.UrlsConstants.appsEntryPoint
    let method = Constants.MethodsWSConstants.APPS.UPDATE_APP+'APPLICATION_ADMIN'
    fetch(urlServer+entryPoint+method, {
      method: 'PUT',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify({
        id: application.id,
        status: application.status,
        versionCode: application.versionCode,
        deactivateCheckPwd: application.deactivateCheckPwd,
        usersFO: application.usersFO,
      }),
    })
    .then(response => {
      tokenInterceptor(response)
      return responseHandler(response)
    })
    .then(data => {
      dispatch(loaded('Error.Croutons.saveSuccess'))
      clearAllApps()
      getAllApps()
    })
    .catch(error => {
      if (errorGetStatus(error) === 401) {
        dispatch(errorLoading('Error.Croutons.authExpired'))
        fetchLogoutAction(dispatch).fetchLogout()
      }
    })
  }

  function deleteApp () {
    if (application) {
      dispatch(loading(''))
      let method = Constants.UrlsConstants.appsEntryPoint+'admin/' + application.id
      // dispatch(loading(method))
      fetch(urlServer+method, {
        method: 'DELETE',
        headers: Constants.UrlsConstants.header,
      })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        clearAllApps()
        getAllApps()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
    }
  }

  function addToTeamAndApp () {
    let entryPoint = Constants.UrlsConstants.teamEntryPoint
    let method = Constants.MethodsWSConstants.APPS.ADD_TEAM_APP + application.id
    fetch(urlServer+entryPoint+method, {
      method: 'POST',
      headers: Constants.UrlsConstants.header,
    })
    .then(response => {
      tokenInterceptor(response)
      return responseHandler(response)
    })
    .then(data => {
      dispatch(loaded('Error.Croutons.saveSuccess'))
      clearAllApps()
      getAllApps()
    })
    .catch(error => {
      if (errorGetStatus(error) === 401) {
        dispatch(errorLoading('Error.Croutons.authExpired'))
        fetchLogoutAction(dispatch).fetchLogout()
      } else {
        dispatch(errorLoading('Error.Croutons.saveError'))
      }
    })
  }

  return {
    clearAllApps,
    getAllApps,
    saveApp,
    deleteApp,
    addToTeamAndApp,
  }
}
